import type { NskResponse } from "~/models/Api";
import type { UpdateParams } from "~/models/DealPartnerAssignment";
import { putRequest } from "~/utils/api/api_handler";
import { generatePath } from "~/utils/generatePath";

export const paths = {
	update: (dealId: number) =>
		generatePath("/vendors/deals/:deal_id/deal_partner_assignment", {
			deal_id: dealId
		})
};

export const update = async (
	dealId: number,
	params: UpdateParams
): Promise<NskResponse> => putRequest(paths.update(dealId), params);
